/*
Rajesh 11/14/2022 2699282118 Add night jobs New UX.
Ashraf 11/14/2022 2699282118 added add night jobs new fields
Rajesh 11/15/2022 2699282118 Add onClick event for next button.
akhila 11/15/2022 2699282118 added dropDown in priority field
Prakash 11/16/2022 2699282118  Fixed Validation Alignments.
akhila 11/18/2022 2699282118 integrated post api and get api .
akhila 11/18/2022 2699282118  fixed get api payload issues.
akhila 11/19/2022 2699282118 fixed label issues
Rajesh 11/23/2022 2699282118 added nextruntime and lastruntime fields.
Guru Prasad 11/22/2022 2699282118  Fixed chips alignments in textfield.
Saikrishna 11/24/2022 2699217591 Fixed draft mode payload bug
Akhila 11/25/2022 2699282118 rename the status field label and validation message
Rajesh 11/25/2022  2699282118 fixed validation issue
Rajesh 11/28/2022  2699282118 disabled job code and job name in edit
Ravi 11/28/2022 2699217591 fixed date field validation
Suresh Peddavoora 11/28/2022 2699282118 Fixed Text Field Dropdown issue
Dilip 11/28/2022 2699282118 added unsave alert popup
Dilip 11/28/2022 2699282118 removed codes in priority dropdown
lalitha 11/28/2022 2699282118 added prepopulating data in JobName field
Ravi 11/29/2022 2699282118 fixed  job descrption field validation
Lalitha 30/11/2022 2699282118   Added validation on code
Rajesh 01/12/2022 2699282118 validation remove for job description
Akhila 12/02/2022 2699282118 bug fix validation on mandatory field on existing user
Sai maheshwar 12/04/2022 2699282118 added unsaved changes alert
Saikrishna 12/02/2022 3225736869 Added create for dropdown and defaulted status dropdown to not scheduled
Saikrishna 12/06/2022 3225736869 Fixed created for field issues and removed job name.
lalitha 12/06/2022 3225736869 changed place holder
lalitha 12/06/2022 3225736869 renamed Job Description in validation
akhila 12/07/2022 3225736869 added default value for createdFor
Saikrishna 12/09/2022 3225736869 save and stay in page functionality added.
Rohini 12/13/2022 3225736869 Fixed save button alignments
Ashraf 12/16/2022 3225736869 fixed role based access
Ashraf 12/16/2022 3225736869 fixed role based access
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
akhila 12/18/2022  3225736869 fixed notifyError and notifyCompletion bug
akhila 12/21/2022 3225736869 fixed date time formate
akhila 12/22/2022 3225736869 removed last and next run time in payload
prakash 22/26/2022  3225736869 fixed alignments issue for button
akhila 12/26/2022 3225736869 fixed startDate and Date issue
dilip 12/27/2022 3225736869 fixed unsaved popup issue
dilip 12/27/2022 3225736869 fixed unsaved popup issue after touching the Autocomplete
lalitha 28/12/2022 3225736869 Removed Higher priority from priority field. set Medium priority as default
Ashraf 01/02/2022 3225736869 fixed white space validation issue
Ashraf 01/05/2023 3225736869 fixed time format issue
Lalitha 01/12/2023 3225736869 fixed code validation issue
Sohel 02/08/2023 3225736869 added Client Code Dropdown
Sohel 02/08/2023 3225736869 Fixed Client Code populate issue
Sohel 02/09/2023 3225736869 client DropDown value changes
Sohel 02/13/2023 3225736869 Added Job Code validation
suresh peddavoora 0/21/2023 3225736869 New UI changes
suresh peddavoora 02/22/2023 3225736869 New UI changes
Raghu 02/24/2023 3225736869 New UI changes
Raghu 02/24/2023 3225736869 check box fixes
Raghu 02/27/2023 3225736869 fixed input alignments
suresh peddavoora 03/06/2023 3225736869 New UI changes
Ravi 04/19/2023 3225736869 modified client code dropDownData data.
Ravi 04/26/2023 3225736869 Added Notes Field .
Prakash 26/04/2023 3225736869 fixed alignments issue in scheduler
Ravi 04/27/2023 3225736869 fixed Messege disply issue in notes field.
Prakash 15-05-2023 3225736869 Fixed alignments issue in tab view.
Akhila 06/14/2023 3225736869 added condtionally retry after field
Sohel 06/15/2023 3225736869 Fixed Date Format Issue
Sohel 06/22/2023 3225736869 Fixed No of Retries default value
Akhila 06/22/2023 3225736869 conditionally disable save and finish button on submission
*/
import {
  Button,
  TextField,
  FormHelperText,
  FormControl,
  Grid,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import React, {useState, useEffect, useRef, useContext} from 'react';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../../components/PageLoader';
import {
  postAddNightJob,
  fetchAllJobCodesAndJobNames,
  resetMessage,
} from './../../../../../../redux/reducers/NightJobs/AddNightJob';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import {Formik} from 'formik';
import {NumFormatter} from '../../../../../../components/UserDefinedForm/AppTextInputComponents';
import DateFnsUtils from '@date-io/date-fns';
import {getAllReportCreatedForData} from '../../../../../../redux/reducers/ReportMaster';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {getClientCodeDropDownData} from '../../../../../../redux/reducers/TriggerGroup';
import {submissionStart} from '../../../../../../redux/reducers/CommonActions/commonActions';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {createForOptions} from '../../../../../../util/CreatedByForOptions';
// import {nameWithSpecialCharacter} from '../../../../../../util/Content';
// import {nameRegexAllow} from '../../../../../../util/RegexPatterns';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const NightJobBasicInfo = ({
  isCopyRowData,
  activeStep,
  handleNext,
  handleBack,
  handleDirty,
  selected,
  setSaveTab,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(getClientCodeDropDownData());
  }, []);
  const {reportCreatedForData} = useSelector(({reportMaster}) => reportMaster);
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const dataRef = useRef(true);
  const {
    isLoading,
    successMsg,
    errorMsg,
    nightJobData,
    addNightJob,
    allJobCodesAndJobNames,
    jobDetailsData,
  } = useSelector(({addNightJob}) => addNightJob);
  const [jobCodesData, setJobCodesData] = useState();
  const [codePopover, setCodePopover] = useState(false);
  const saveRef = useRef();

  const {roleData} = useSelector(({role}) => role);

  const roleAccess = roleData?.window?.['Scheduler']?.SC;

  const prioritys = [
    {key: '1', value: 'High'},
    {key: '2', value: 'Medium'},
    {key: '3', value: 'Low'},
  ];
  const getSelectObject = (options, option) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.key === option || item.userName === option || item.userLoginName === option) {
          label = item;
        }
      });
    return label;
  };

  useEffect(() => {
    dispatch(fetchAllJobCodesAndJobNames());
    setSaveTab(false);
  }, []);

  const checkJobCodeExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if (
          i?.jobCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkJobCodeAlreadyExist = (value) => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0 && value) {
      const ar = [];
      allJobCodesAndJobNames.filter((i) => {
        if (
          i?.jobCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const getJobCodesData = () => {
    if (allJobCodesAndJobNames && allJobCodesAndJobNames?.length > 0) {
      return allJobCodesAndJobNames?.filter((i) => String(i?.jobCode)?.startsWith(jobCodesData));
    } else {
      return [];
    }
  };
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialValues = {
    code: isCopyRowData ? '' : jobDetailsData?.jobCode || '',
    jobName: jobDetailsData?.jobName ? jobDetailsData?.jobName : '',
    description: jobDetailsData?.jobDescription ? jobDetailsData?.jobDescription : '',
    // status: jobDetailsData?.jobStatus
    //   ? getSelectObject(statuses, jobDetailsData?.jobStatus)
    //   : { key: "Not scheduled", value: "Not scheduled" },
    notifyCompletion:
      jobDetailsData?.notifyCompletionEmails?.length > 0 &&
      typeof jobDetailsData?.notifyCompletionEmails === 'object' ?
        jobDetailsData?.notifyCompletionEmails?.join(',') :
        '',
    notifyError:
      jobDetailsData?.notifyErrorEmails?.length > 0 &&
      typeof jobDetailsData?.notifyErrorEmails === 'object' ?
        jobDetailsData?.notifyErrorEmails?.join(',') :
        '',
    priority: jobDetailsData?.priority ?
      getSelectObject(prioritys, jobDetailsData?.priority.toString()) :
      {key: '2', value: 'Medium'},
    createdFor: jobDetailsData?.createdFor ?
      getSelectObject(reportCreatedForData, jobDetailsData?.createdFor) :
      {userLoginName: user?.userName},
    noOfRetries: jobDetailsData?.noOfRetries ? String(jobDetailsData?.noOfRetries) : '0',
    retryAfter: jobDetailsData?.retryAfter ? jobDetailsData?.retryAfter : 30,
    // The date is formatted to UTC on the BE side, so commenting now from the FE side.
    // nextRunTime: jobDetailsData?.nextRunTime
    //   ? moment(jobDetailsData?.nextRunTime).tz("America/New_York").utc().format("MM/DD/YYYY hh:mm:ss")
    //   : "",
    // lastRunTime: jobDetailsData?.lastRunTime ? moment(jobDetailsData?.lastRunTime).tz("America/New_York").format("MM/DD/YYYY hh:mm:ss") : "",
    nextRunTime: jobDetailsData?.nextRunTime ? jobDetailsData?.nextRunTime : '',
    lastRunTime: jobDetailsData?.lastRunTime ? jobDetailsData?.lastRunTime : '',
    user:
      jobDetailsData?.clientNumbers?.length > 0 ?
        getClientCodes(jobDetailsData?.clientNumbers, clientCodeDropdownData) :
        [],
    specialNotes: jobDetailsData?.importantNotes ? jobDetailsData?.importantNotes : '',
  };

  const validationSchema = Yup.object().shape({
    code: initialValues.code ?
      null :
      Yup.string()
        .required('Job Name is required')
        .max(25, 'Job Name cannot exceed 25 characters')
        .test('code', 'Job Name already in use', (value) => !checkJobCodeExist(value))
        .test(
          'code',
          'Job Name has already been used in the past',
          (value) => !checkJobCodeAlreadyExist(value),
        )
        .max(25, 'Job Name cannot exceed 25 characters'),
    // jobName: initialValues.jobName
    //   ? null
    //   : Yup.string()
    //       .required("Job name is required")
    //       .matches(/^[a-zA-Z0-9]+$/, "White spaces and special characters are not allowed")
    //       .test("jobName", "Job name already exist", (value) => !checkJobNameExist(value)),
    description: Yup.string()
      .required('Job Description is required')
      .max(100, 'Job Description cannot exceed 100 characters'),
    // .test("description",codeValidationMessage,(val)=>{
    //   let pattern = /^\s+$/g;
    //   const res = val?.match(pattern);
    //   if(res){
    //     return false;
    //   }else {
    //     return true;
    //   }
    // })
    // status: Yup.mixed().test("status", "Scheduled Status is required", (value) => {
    //   if (!value?.key) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    notifyCompletion: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    notifyError: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    specialNotes: Yup.mixed().test(
      'specialNotes',
      'Important Notes can\'t be more than 500 characters',
      (value) => {
        if (value?.length > 500) {
          return false;
        } else {
          return true;
        }
      },
    ),
  });

  useEffect(() => {
    if (Object.keys(nightJobData).length > 0) {
      // reset(initialValues);
      const ruleData =
        nightJobData.tasks &&
        nightJobData.tasks.map((data) => {
          const newObj = {
            ...data,
            id: data.id,
            taskCode: data.code,
            taskType: data.type,
            parameters: data.parameters,
            tableData: {checked: true, id: data.jobId},
          };
          return newObj;
        });
      const sortedData = [...ruleData];
      sortedData.sort((a, b) => a['sequence'] - b['sequence']);
    }
  }, [nightJobData]);

  useEffect(() => {
    if (addNightJob === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
      }, 2000);
    }
  }, [addNightJob]);
  // useEffect(() => {
  //   if (jobDataId) {
  //     dispatch(fetchJobDetails(jobDataId));
  //   }
  // }, [jobDataId]);

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const clientNumber =
      values?.user?.length > 0 ? values?.user?.map((el) => el?.clientNumber) : [];
    const passValues1 = {
      createdFor: values?.createdFor?.userLoginName ? values?.createdFor?.userLoginName : '',
      deleteTaskIds: [0],
      jobCode: values?.code ? values?.code : '',
      jobDescription: values?.description ? values?.description : '',
      jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
      jobName: values?.jobName ? values?.jobName : '',
      // jobStatus: values?.status?.value ? values?.status?.value : "",
      noOfRetries: values?.noOfRetries ? values?.noOfRetries : 0,
      notifyCompletionEmails: values?.notifyCompletion.length ?
        values?.notifyCompletion?.split(',') :
        [],
      notifyErrorEmails: values?.notifyError.length ? values?.notifyError?.split(',') : [],
      priority: values?.priority?.key ? values?.priority?.key : 0,
      retryAfter: values?.retryAfter ? values?.retryAfter : '',
      isDraft: jobDetailsData?.taskRequest?.length > 0 ? 'N' : 'Y',
      taskRequest: jobDetailsData?.taskRequest ? jobDetailsData?.taskRequest : [],
      clientNumbers: clientNumber,
      importantNotes: values?.specialNotes ? values?.specialNotes : '',
      tabType: 'Schedule',
    };
    dispatch(postAddNightJob(passValues1));
  };
  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
            setTouched,
            touched,
            errors,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <div className="  global-field-textfields new-standard-textfields px-2">
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2}>
                        <Grid item xs={4} className={`${errors?.code?.length > 30 ? 'form-group-lg' : 'form-group'}`}>
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Job Name"
                            margin="dense"
                            name="code"
                            variant="outlined"
                            disabled={jobDetailsData?.jobCode}
                            label="Job Name"
                            required
                            inputProps={{maxLength: 25}}
                            onBlur={handleBlur}
                            value={values?.code}
                            onChange={(e) => {
                              setFieldValue('code', e.target.value);
                              if (e.target.value) {
                                setCodePopover(true);
                                setJobCodesData(e.target.value);
                              } else if (e.target.value === '') {
                                setCodePopover(false);
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            error={Boolean(touched.code && errors.code)}
                          />
                          <FormHelperText variant="outlined">
                            {touched.code && errors.code ? errors.code : ''}
                          </FormHelperText>
                          <div className="windowcode-popover">
                            {codePopover &&
                              getJobCodesData()?.map((data, i) => (
                                <MenuItem key={i}>{data?.jobCode}</MenuItem>
                              ))}
                          </div>
                        </Grid>
                        {/* <Grid item xs={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Job Name"
                          margin="dense"
                          name="jobName"
                          variant="outlined"
                          label="Job Name"
                          onBlur={handleBlur}
                          value={values?.jobName}
                          disabled={jobDetailsData?.jobName}
                          required
                          onChange={(e) => {
                            setFieldValue("jobName", e.target.value);
                            if (e.target.value) {
                              setNamePopover(true)
                              setJobNamesData(e.target.value)
                            } else if (e.target.value === "") {
                              setNamePopover(false)
                            }
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          error={Boolean(touched.jobName && errors.jobName)}
                        />
                        <FormHelperText variant="outlined">
                          {touched.jobName && errors.jobName ? errors.jobName : ""}
                        </FormHelperText>
                        <div className="windowcode-popover">
                          {namePopover &&
                            getJobNamesData()?.map((data, i) => (
                              <MenuItem key={i}>{data?.jobName}</MenuItem>
                            ))}
                        </div>
                      </Grid> */}
                        <Grid item xs={4} className="form-group">
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Job Description"
                            margin="dense"
                            name="description"
                            variant="outlined"
                            label="Job Description"
                            required
                            value={values?.description}
                            inputProps={{maxLength: 100}}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('description', e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            error={Boolean(touched.description && errors.description)}
                          />
                          <FormHelperText variant="outlined">
                            {touched.description && errors.description ? errors.description : ''}
                          </FormHelperText>
                        </Grid>
                        {/* <Grid item xs={4} className="form-group">
                        <GuiAutoComplete
                          {...props}
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          id="status"
                          options={statuses}
                          size="small"
                          autoHighlight
                          value={values?.status}
                          onBlur={handleBlur}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option?.value ? option.value : "";
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              margin="dense"
                              fullWidth
                              required
                              error={Boolean(touched.status && errors.status)}
                              label="Scheduled Status"
                              name="status"
                              placeholder="Select Scheduled Status"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "off",
                              }}
                            />
                          )}
                          onChange={(_, data) => {
                            setFieldValue("status", data);
                          }}
                        />
                        <FormHelperText variant="outlined">
                          {touched.status && errors.status ? errors.status : ""}
                        </FormHelperText>
                      </Grid> */}
                        <Grid item xs={4} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="createdFor"
                            id="createdFor"
                            size="small"
                            value={values.createdFor}
                            options={reportCreatedForData}
                            getOptionLabel={(option) => {
                              return option && option?.userLoginName ? option?.userLoginName : '';
                            }}
                            renderOption={(option) => {
                              return createForOptions(option);
                            }}
                            onChange={(e, value) => {
                              setFieldValue('createdFor', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Created For"
                                  className={`${classes.labelName}`}
                                  placeholder="Select Created For"
                                />
                                <FormHelperText variant="outlined">
                                  {touched.createdFor && errors.createdFor}
                                </FormHelperText>
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item xs={4} className={`form-group `}>
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Notify Completion Emails"
                            margin="dense"
                            name="notifyCompletion"
                            variant="outlined"
                            value={values?.notifyCompletion}
                            label="Notify Completion Emails"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('notifyCompletion', e.target.value);
                              // if (e.target.value) {
                              //   setCodePopover(true);
                              //   setReportCodesData(e.target.value);
                              // } else if (e.target.value === "") {
                              //   setCodePopover(false);
                              // }
                            }}
                            // touched={touched.notifyCompletion}
                            // error={Boolean(errors.notifyCompletion && touched.notifyCompletion)}
                            fullWidth
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.notifyCompletion && errors.notifyCompletion}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={4} className={`form-group `}>
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Notify Error Emails"
                            margin="dense"
                            name="notifyError"
                            variant="outlined"
                            value={values?.notifyError}
                            label="Notify Error Emails"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('notifyError', e.target.value);
                              // if (e.target.value) {
                              //   setCodePopover(true);
                              //   setReportCodesData(e.target.value);
                              // } else if (e.target.value === "") {
                              //   setCodePopover(false);
                              // }
                            }}
                            // touched={touched.notifyError}
                            // error={Boolean(errors.notifyError && touched.notifyError)}
                            fullWidth
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched.notifyError && errors.notifyError}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={4} className="form-group">
                          <GuiAutoComplete
                            {...props}
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            id="priority"
                            options={prioritys}
                            size="small"
                            autoHighlight
                            value={values?.priority}
                            // getOptionDisabled={(option) => option.valueCode === null}
                            getOptionLabel={(option) => {
                              return option?.value ? option.value : '';
                            }}
                            renderInput={(params) => (
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                margin="dense"
                                fullWidth
                                error={Boolean(errors.priority)}
                                label="Priority"
                                name="priority"
                                placeholder="Select Priority"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            )}
                            onChange={(_, data) => {
                              setFieldValue('priority', data);
                            }}
                          />
                          <FormHelperText variant="outlined">
                            {touched && errors.priority ? errors.priority : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={4} className="form-group">
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter No Of Retries"
                            margin="dense"
                            name="noOfRetries"
                            variant="outlined"
                            label="No Of Retries"
                            value={values?.noOfRetries}
                            InputProps={{
                              inputComponent: NumFormatter,
                            }}
                            onChange={(e) => {
                              setFieldValue('noOfRetries', e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            // error={Boolean(errors.noOfRetries)}
                          />
                          <FormHelperText variant="outlined">
                            {touched && errors.noOfRetries ? errors.noOfRetries : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={4} className="form-group">
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Retry After"
                            margin="dense"
                            name="retryAfter"
                            variant="outlined"
                            label="Retry After (mins)"
                            value={values?.retryAfter}
                            disabled={Number(values?.noOfRetries) > 0 ? false : true}
                            InputProps={{
                              inputComponent: NumFormatter,
                            }}
                            onChange={(e) => {
                              setFieldValue('retryAfter', e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                            error={Boolean(errors.retryAfter)}
                          />
                          <FormHelperText variant="outlined">
                            {touched && errors.retryAfter ? errors.retryAfter : ''}
                          </FormHelperText>
                        </Grid>
                        {jobDetailsData?.nextRunTime ? (
                          <Grid item xs={4} className="form-group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardDateTimePicker
                                  className={`${classes.labelName}`}
                                  orientation="portrait"
                                  format="MM/dd/yyyy hh:mm:ss a"
                                  placeholder="MM/DD/YYYY"
                                  value={values.nextRunTime}
                                  fullWidth
                                  disabled
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  name="nextRunTime"
                                  inputVariant="outlined"
                                  label="Next Run Date & Time"
                                  autoOk
                                  margin="dense"
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                          </Grid>
                        ) : (
                          ''
                        )}
                        {jobDetailsData?.lastRunTime ? (
                          <Grid item xs={4} className="form-group start-enddate">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardDateTimePicker
                                  className={`${classes.labelName}`}
                                  orientation="portrait"
                                  format="MM/dd/yyyy hh:mm:ss a"
                                  placeholder="MM/DD/YYYY"
                                  value={values.lastRunTime}
                                  fullWidth
                                  disabled
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  name="lastRunTime"
                                  inputVariant="outlined"
                                  label="Last Run Date & Time"
                                  autoOk
                                  margin="dense"
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                          </Grid>
                        ) : (
                          ''
                        )}
                        <Grid
                          item
                          xs={4}
                          className={`autocomplete-field form-group ${
                            values?.user?.length > 2 && `autocomplete-checkbox`
                          }`}
                        >
                          <FormControl margin="dense" variant="outlined" fullWidth>
                            <GuiAutoComplete
                              name={'user'}
                              id={'user'}
                              size="small"
                              limitTags={1}
                              classes={{
                                option: classes.option,
                                listbox: classes.listBox,
                              }}
                              disableCloseOnSelect
                              getOptionSelected={(option, value) =>
                                option?.clientNumber === value?.clientNumber
                              }
                              value={values?.user?.length > 0 ? values?.user : []}
                              multiple
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('user', value);
                              }}
                              options={clientCodeDropdownData || []}
                              autoHighlight
                              renderOption={(option, {selected}) => {
                                return (
                                  <React.Fragment>
                                    <>
                                      <Checkbox
                                        className={`checkBox ${classes.labelName}`}
                                        icon={icon}
                                        checkedIcon={
                                          <CheckBoxIcon
                                            fontSize="small"
                                            className="selectcheckBox"
                                          />
                                        }
                                        checked={selected}
                                      />
                                    </>
                                    {/* {option?.clientNumber} - {option?.clientName} */}
                                    {option?.clientName}
                                  </React.Fragment>
                                );
                              }}
                              getOptionLabel={(option) => {
                                // return option?.clientNumber + " - " + option?.clientName;
                                return option?.clientName;
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    className={`autocomplete-multiselect-label ${classes.labelName}`}
                                    variant="outlined"
                                    margin="dense"
                                    touched={touched}
                                    error={touched?.user && errors?.user}
                                    // InputLabelProps={{ shrink: true }}
                                    label={'Client Code'}
                                    placeholder={`Select Client Code`}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                  />
                                </div>
                              )}
                            />
                          </FormControl>
                          <FormHelperText variant="outlined">
                            {touched?.user && errors?.user ? errors.user : ''}
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div
                    className={`internal-notepad new-standard-textfields mb-3 px-3 ${classes.specialNeeds} ${classes.notesError}`}
                  >
                    <TextField
                      multiline={true}
                      minRows={6}
                      // autoFocus
                      margin="dense"
                      // disabled={play}
                      spellCheck="true"
                      variant="outlined"
                      className={`${classes.labelName}`}
                      placeholder={`Enter Important Notes`}
                      value={values?.specialNotes}
                      error={Boolean(touched?.specialNotes && errors.specialNotes)}
                      onChange={(e) => {
                        // handleFilter(e?.target?.value?.trimStart());
                        setFieldValue('specialNotes', e.target.value);
                        setTouched({...touched, specialNotes: true});
                        dataRef.current = true;
                      }}
                      label={'Important Notes'}
                      // inputRef={register({
                      //   maxLength: {
                      //     value: 500,
                      //     message: "Cannot exceed 500 characters",
                      //   },
                      // })}
                      inputProps={{
                        spellCheck: true,
                        lang: 'en',
                        // maxLength: 500,
                      }}
                      name="specialNotes"
                      fullWidth={true}
                    />
                    {values?.specialNotes?.length > 0 &&
                    values?.specialNotes?.length < 500 &&
                    touched?.specialNotes &&
                    dataRef.current ? (
                        <FormHelperText variant="outlined">
                          <div style={{color: 'blue'}}>
                          Important Notes Allows {500 - values?.specialNotes?.length} More
                          characters.
                          </div>
                        </FormHelperText>
                      ) : (
                        <FormHelperText variant="outlined">
                          {touched?.specialNotes && errors.specialNotes ? errors.specialNotes : ''}
                        </FormHelperText>
                      )}
                  </div>
                  <div className="d-flex justify-content-center new-standard-textfields disabled-button">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      disabled={activeStep === 0}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    <Button
                      variant="outlined"
                      // type="submit"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      disabled={
                        (!roleAccess?.edit && jobDetailsData?.jobCode && selected) ||
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = true;
                        dataRef.current = false;
                        handleDirty(false, 'fixed');
                        handleSubmit();
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant="outlined"
                      // type="submit"
                      disabled={
                        (!roleAccess?.edit && jobDetailsData?.jobCode && selected) ||
                        enabledSubmission
                      }
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        saveRef.current = false;
                        dataRef.current = false;
                        handleSubmit();
                      }}
                    >
                      Save & Next
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
      {/* </form> */}
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default NightJobBasicInfo;
